import React from 'react';
import { useGlobalState } from '../../state';

const PointItem = () => {
  const [value] = useGlobalState('totalPoints');

  let score = value;
  if (value > 1425) {
    score = 1425;
  } 
  if (value === 1375) {
    score = 1425;
  } 
  return (
    <React.Fragment>
      {score.toLocaleString()} <span>XPs</span>
    </React.Fragment>
  );
};

export default PointItem;
